<template>
  <div class="rematch-mark" aria-label="Этот участник предложил реванш">
    <span class="rematch-mark__wash" :style="washStyle" aria-hidden="true"></span>
    <span class="rematch-mark__letter" aria-hidden="true">R</span>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  // The fraction comes from the authoritative deadline, never a CSS timer.
  progress: { type: Number, default: 0 },
});

const washStyle = computed(() => ({
  "--rematch-cleared": String(Math.min(1, Math.max(0, Number(props.progress) || 0)) * 360) + "deg",
}));
</script>

<style scoped>
.rematch-mark {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: grid;
  place-items: center;
  overflow: hidden;
  border: 2px solid var(--game-rematch-green);
  border-radius: inherit;
  pointer-events: none;
}
.rematch-mark__wash {
  position: absolute;
  inset: 0;
  background: conic-gradient(from 0deg, transparent 0deg var(--rematch-cleared), var(--game-rematch-wash) var(--rematch-cleared) 360deg);
}
.rematch-mark__letter {
  position: relative;
  color: var(--cb-text);
  font-size: clamp(42px, 14vw, 72px);
  font-weight: 800;
  line-height: 1;
  text-shadow: 0 2px 12px var(--cb-overlay);
}
</style>
